import React from "react";
import "./nav-icon-styles.scss";

function NavIcon({ icon }) {
  return <span className={`nav-menu-icon nav-menu-icon-${icon}`} />;
}

export default NavIcon;
